module.exports = __webpack_public_path__ + "img/img.4d53d101.png";